import React from 'react';
import { Form } from 'react-bootstrap';

interface InputCheckProps {
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  Checked?: boolean;
  ClassName?: string;
  Feedback?: string;
  HandleChange: (event: any) => void;
  Id: string;
  Inline?: boolean;
  IsDisabled?: boolean;
  IsInvalid?: boolean;
  IsReadOnly?: boolean;
  IsRequired?: boolean;
  Label?: string;
  Name?: string;
  Type?: 'checkbox' | 'radio';
}

const InputCheck = ({
  Checked = null,
  ClassName = 'mb-24',
  Feedback = null,
  HandleChange,
  Id,
  Inline = false,
  IsDisabled = false,
  IsInvalid = false,
  IsReadOnly = false,
  IsRequired = true,
  Label = null,
  Name = null,
  Type = 'checkbox',
}: InputCheckProps) => {
  return (
    <Form.Group className={ClassName} id={Id}>
      <Form.Check inline={Inline} onChange={HandleChange}>
        <Form.Check.Input
          checked={Checked}
          disabled={IsDisabled || IsReadOnly}
          isInvalid={IsInvalid}
          name={Name !== null ? Name : Id}
          readOnly={IsReadOnly}
          required={IsRequired}
          type={Type}
          onChange={HandleChange}
        />
        {Label && (
          <Form.Check.Label
            className={`form-label fw-normal${IsRequired ? ' required' : ''}${
              IsReadOnly ? ' readonly' : ''
            }`}
          >
            {Label}
          </Form.Check.Label>
        )}
        {Feedback && IsInvalid && (
          <Form.Control.Feedback type="invalid">
            {Feedback}
          </Form.Control.Feedback>
        )}
      </Form.Check>
    </Form.Group>
  );
};

// InputCheck.defaultProps = {
//   Checked: null,
//   ClassName: 'mb-24',
//   Feedback: null,
//   Inline: false,
//   IsDisabled: false,
//   IsInvalid: false,
//   IsReadOnly: false,
//   IsRequired: true,
//   Label: null,
//   Name: null,
//   Type: 'checkbox',
// };

export default InputCheck;
export { InputCheck };
export type { InputCheckProps };
